import { render } from "./footer.vue?vue&type=template&id=0dca0c4c"
const script = {}

import exportComponent from "C:\\www\\LEVO-WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__